import { render, staticRenderFns } from "./edito.vue?vue&type=template&id=3c670440"
import script from "./edito.vue?vue&type=script&lang=js"
export * from "./edito.vue?vue&type=script&lang=js"
import style0 from "./edito.vue?vue&type=style&index=0&id=3c670440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./edito.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsEditoNavigation: require('/home/node/app/components/patterns/edito-navigation/edito-navigation.vue').default,PatternsEditoHeader: require('/home/node/app/components/patterns/edito-header/edito-header.vue').default,TemplatesEditoContent: require('/home/node/app/components/templates/edito-content/edito-content.vue').default,ElementsEditoFootnotes: require('/home/node/app/components/elements/edito-footnotes/edito-footnotes.vue').default})
